// extracted by mini-css-extract-plugin
export default {"subnavMenu":"PrimaryMenuSubNav_subnavMenu__pxY0x","subnavMenuText":"PrimaryMenuSubNav_subnavMenuText__tGmqG"};